var r, n;
function i() {
  if (n) return r;
  n = 1;
  function u(e, o) {
    var t = e.length;
    for (e.sort(o); t--; )
      e[t] = e[t].value;
    return e;
  }
  return r = u, r;
}
export {
  i as __require
};
